import * as React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
// Utilities
import cs from "classnames";
import { get } from "lodash";
import { AppStore } from "state/index";
import { observer, inject } from "mobx-react";
// UI Framework
import { Layout, Menu, Icon, Modal } from "antd";
// Hiiks and utilities
import useUser from "hooks/useUser";
// Styles
import styles from "./index.module.scss";
// Assets
import Logo from "assets/images/baazar.png";

const { Sider: LayoutSider } = Layout;

interface IProps {
	collapsed: boolean;
	appStore?: AppStore;
	onCollapse: (collapsed: boolean) => void;
}

const Sider: React.FC<IProps> = props => {
	const { logout } = useUser();
	const location = useLocation();
	const { confirm } = Modal;

	function logoutUser() {
		confirm({
			title: "خروج از حساب کاربری",
			content: "آیا برای خروج از حساب کاربری خود اطمینان دارید؟",
			onOk() {
				logout();
			},
		});
	}

	return (
		<LayoutSider
			collapsed={!props.collapsed}
			className={styles["sider"]}
			breakpoint="lg"
			collapsedWidth="0"
			onBreakpoint={() => {
				// console.log(broken);
			}}
			onCollapse={collapsed => {
				props.onCollapse(!collapsed);
			}}
		>
			<div>
				<div className={styles["sider__logo"]}>
					<img src={Logo} alt="سامانه بازر" height="64" />
				</div>
				<div className={styles["sider__title"]}>سامانه بازر</div>
			</div>

			<Menu
				selectedKeys={[location.pathname.replace(/\//g, "_")]}
				theme="dark"
				mode="inline"
				defaultSelectedKeys={["/dashboard/link1"]}
			>
				<Menu.Item key="_dashboard">
					<NavLink exact={true} to="/dashboard">
						<Icon type="dashboard" />
						<span className={styles["sider__link-text"]}>داشبورد</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_deposit">
					<NavLink to="/dashboard/deposit">
						<Icon type="wallet" />
						<span className={styles["sider__link-text"]}>شارژ کیف پول</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_issue">
					<NavLink exact={true} to="/dashboard/issue">
						<Icon type="arrow-down" />
						<span className={styles["sider__link-text"]}>خرید طلا</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_sell">
					<NavLink exact={true} to="/dashboard/sell">
						<Icon type="arrow-up" />
						<span className={styles["sider__link-text"]}>فروش طلا</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_settlements_request">
					<NavLink exact={true} to="/dashboard/settlements/request">
						<Icon type="wallet" />
						<span className={styles["sider__link-text"]}>تسویه ریالی</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_financials">
					<NavLink to="/dashboard/financials">
						<Icon type="snippets" />
						<span className={styles["sider__link-text"]}>گزارشات</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_bank_accounts">
					<NavLink exact={true} to="/dashboard/bank/accounts">
						<Icon type="bank" />
						<span className={styles["sider__link-text"]}>حسابهای بانکی</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_physical_gold">
					<NavLink exact={true} to="/dashboard/physical/gold">
						<Icon type="gold" />
						<span className={styles["sider__link-text"]}>دریافت طلای فیزیکی</span>
					</NavLink>
				</Menu.Item>

				<Menu.Item key="_dashboard_tickets">
					<NavLink exact={true} to="/dashboard/tickets">
						<Icon type="tag" />
						<span className={styles["sider__link-text"]}>تیکت ها</span>
					</NavLink>
				</Menu.Item>

				{/* <Menu.Item key="menu_services">
					<NavLink to="#">
						<Icon type="ordered-list" />
						<span className={styles["sider__link-text"]}>خدمات</span>
					</NavLink>
				</Menu.Item> */}

				{/*<Menu.Item key="menu_support">
					<NavLink to="#">
						<Icon type="global" />
						<span className={styles["sider__link-text"]}>پشتیبانی</span>
					</NavLink>
				</Menu.Item>*/}
			</Menu>
			<div className={styles["sider__footer"]}>
				<div className={cs(styles["sider__logout"], styles["logout-box"])} onClick={logoutUser}>
					<Icon type="poweroff" className={styles["logout-box__icon"]} />
					<span className={styles["logout-box__link-text"]}>خروج از حساب کاربری</span>
				</div>
				<div className={styles["sider__app-version"]}>
					v{process.env.APP_VERSION} - {get(props.appStore, ["version"])}
				</div>
			</div>
		</LayoutSider>
	);
};

export default inject("appStore")(observer(Sider));
